module.exports = __webpack_public_path__ + "static/media/logo_B.7a930ce2.svg";